import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { SharedModule } from "app/shared/shared.module";
import { HelpLayoutComponent } from "./help-layout/help-layout.component";
import { RentalTermsComponent } from "./rental-terms/rental-terms.component";
import { MarketingModule } from "@rubbl-marketing";
import { RubblSharedModule } from "@rubbl-shared";
import { LayoutModule } from "@rubbl-layout";

const routes: Routes = [
  {
    path: "",
    component: HelpLayoutComponent,
    children: [
      {
        path: "index", // keep this path until we update our TOS Links
        component: RentalTermsComponent,
      },
      {
        path: "rental-terms",
        component: RentalTermsComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [HelpLayoutComponent, RentalTermsComponent],
  imports: [CommonModule, RouterModule.forChild(routes), SharedModule, RubblSharedModule, MarketingModule, LayoutModule],
})
export class HelpModule {}
